import { Box, Button, Card, Grid, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import AccountGroupsService from "services/account-groups";

const initialValues = {
  dataInicio: "",
  dataFim: "",
  centroDeCusto: "",
  tipo: "contasAPagar", // Default value
  tipoDataFiltrar: "dataVencimento", // could be dataVencimento or dataPedido or dataPagamento
};

export default function RelatorioPorCentroDeCusto() {
  const [loading, setLoading] = useState(false);
  const [showAddCentroDeCusto, setShowAddCentroDeCusto] = useState(false);
  const [childData, setChildData] = useState({});
  const [accountGroups, setAccountGroups] = useState([]);

  useEffect(() => {
    const fetchAccountGroups = async () => {
      try {
        const { data } = await AccountGroupsService.list();
        setAccountGroups(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchAccountGroups();
  }, []);

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const url = new URL(
          `${process.env.REACT_APP_API_URL}reports/relatorio-por-centro-de-custo`
        );

        url.searchParams.append("dataInicio", values.dataInicio);
        url.searchParams.append("dataFim", values.dataFim);
        url.searchParams.append("centroDeCusto", values.centroDeCusto);
        url.searchParams.append("tipo", values.tipo);
        url.searchParams.append("tipoDataFiltrar", values.tipoDataFiltrar);

        window.location.href = url;

        setLoading(false);
      } catch (error) {
        console.error(error);
        alert("Erro ao gerar relatório");
        setLoading(false);
      }
    },
  });

  const selectParent = (parent, value) => {
    formik.setFieldValue(parent, value);
  };

  useEffect(() => {
    const closeOnEscapePressed = (e) => {
      if (e.key === "Escape") {
        if (showAddCentroDeCusto) setShowAddCentroDeCusto(false);
      }
    };
    window.addEventListener("keydown", closeOnEscapePressed);
    return () => window.removeEventListener("keydown", closeOnEscapePressed);
  }, [showAddCentroDeCusto]);

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white" mt={1}>
                  Relatório por Centro de Custo
                </MDTypography>
              </MDBox>
              <MDBox pt={3} mx={2} py={3} px={2}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 2,
                    mb: 2,
                  }}
                  component="form"
                  onSubmit={formik.handleSubmit}
                >
                  <TextField
                    id="dataInicio"
                    name="dataInicio"
                    label="Data Inicial"
                    type="date"
                    value={formik.values.dataInicio}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.dataInicio &&
                      Boolean(formik.errors.dataInicio)
                    }
                    helperText={
                      formik.touched.dataInicio && formik.errors.dataInicio
                    }
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />

                  <TextField
                    id="dataFim"
                    name="dataFim"
                    label="Data Final"
                    type="date"
                    value={formik.values.dataFim}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.dataFim && Boolean(formik.errors.dataFim)
                    }
                    helperText={formik.touched.dataFim && formik.errors.dataFim}
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />

                  <TextField
                    id="centroDeCusto"
                    name="centroDeCusto"
                    label="Centro de Custo"
                    value={formik.values.centroDeCusto}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.centroDeCusto &&
                      Boolean(formik.errors.centroDeCusto)
                    }
                    helperText={
                      formik.touched.centroDeCusto &&
                      formik.errors.centroDeCusto
                    }
                    select
                    SelectProps={{
                      native: true,
                    }}
                    required
                  >
                    <option value="" />
                    {accountGroups.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.descricao}
                      </option>
                    ))}
                  </TextField>

                  <TextField
                    id="tipo"
                    name="tipo"
                    label="Tipo"
                    value={formik.values.tipo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={formik.touched.tipo && Boolean(formik.errors.tipo)}
                    helperText={formik.touched.tipo && formik.errors.tipo}
                    sx={{
                      width: "100%",
                    }}
                    select
                    SelectProps={{
                      native: true,
                    }}
                    required
                  >
                    <option value="contasAPagar">Contas a Pagar</option>
                    <option value="contasAReceber">Contas a Receber</option>
                  </TextField>

                  <TextField
                    id="tipoDataFiltrar"
                    name="tipoDataFiltrar"
                    label="Tipo de Data"
                    value={formik.values.tipoDataFiltrar}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.tipoDataFiltrar &&
                      Boolean(formik.errors.tipoDataFiltrar)
                    }
                    helperText={
                      formik.touched.tipoDataFiltrar &&
                      formik.errors.tipoDataFiltrar
                    }
                    sx={{
                      width: "100%",
                    }}
                    select
                    SelectProps={{
                      native: true,
                    }}
                    required
                  >
                    <option value="dataVencimento">Data de Vencimento</option>
                    <option value="dataPedido">Data de Emissão</option>
                    <option value="dataPagamento">Data de Pagamento</option>
                  </TextField>

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      gridColumn: "span 2",
                      justifySelf: "center",
                      width: "100%",
                      color: "white !important",
                    }}
                  >
                    {loading ? "Carregando..." : "Gerar Relatório"}
                  </Button>
                </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* You'll need to create a component for selecting centro de custo */}
      {showAddCentroDeCusto && (
        <MDBox
          pt={"30px"}
          pb={"5%"}
          px={"5%"}
          sx={{
            position: "absolute",
            zIndex: 9999,
            width: "100vw",
            minHeight: "100vh",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(5px)",
            top: 0,
            right: 0,
            overflow: "auto",
          }}
        >
          {/* Add your CentroDeCusto selection component here */}
          {/* Similar to AdicionarCliente in acerto-cliente.jsx */}
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}
